/**
 * A class to store confirm dialog data
 */
export class ErrorDialogData {
  /**
   * @param title - The title of the error dialog
   * @param message - The message to display in the error dialog
   */
  constructor(public title: string, public message: string) {}
}
